import React, { useState } from "react";
import axios from "axios"; 
import { API_URL } from "../constants";
import { useNavigate } from "react-router-dom";
import Toast from "../DetailsCompteur/Toast";

export default function EditUserForm({ id, rafraichir, token }) {
  const [mail, setMail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [toast, setToast] = useState({ type: '', message: '' });
  const navigate = useNavigate();

  const showToast = (type, message) => {
    setToast({ type, message });
    setTimeout(() => setToast({ type: '', message: '' }), 3000);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateEmail(mail)) {
      showToast('error', 'Adresse e-mail invalide.');
      return;
    }

    setSubmitting(true);
    try {
      const response = await axios.patch(`${API_URL}/user/update`, {
        userId: id,
        email: mail,
      }, {
        headers: {
          "accept": "*/*",
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      });

      showToast('success', response.data.message || 'Adresse mail mise à jour !');
      setMail("");
      rafraichir();
    } catch (error) {
      if (error.response?.status === 401) {
        alert("ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer.");
        localStorage.clear();
        navigate("/login");
        return;
      }
      showToast('error', "Échec de la mise à jour de l'adresse mail.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <p className="text-sm font-medium text-gray-600 mb-3">Changer l'adresse mail</p>
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
        <input
          className="flex-1 border border-gray-300 rounded-lg px-4 py-3 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400"
          onChange={(e) => setMail(e.target.value)}
          value={mail}
          placeholder="Nouvelle adresse mail"
          name="mail"
          type="email"
        />
        <button
          type="submit"
          disabled={submitting}
          className="bg-gradient-to-r from-purple-500 to-indigo-500 text-white px-6 py-3 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 font-medium disabled:opacity-50 whitespace-nowrap"
        >
          {submitting ? 'Mise à jour...' : 'Valider'}
        </button>
      </form>
      <Toast type={toast.type} message={toast.message} />
    </div>
  );
}